import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

const Nav = () => {
  const navigate = useNavigate();

  const handleEnroll = () => {
    navigate('/apply_now');
  };

  return (
    <Box sx={{
      display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', padding: '20px 0',
    }}
    >
      <Box sx={{
        display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
      }}
      >
        <Link style={{ textDecoration: 'none' }} to="/">
          <Typography sx={{
            fontSize: '18px', fontWeight: '500', background: 'linear-gradient(to right, #AE67FA, #F49867)', textFillColor: 'transparent', backgroundClip: 'text',
          }}
          >
            ACCESSIN-CODE
          </Typography>
        </Link>
      </Box>
      <Box sx={{
        display: { xs: 'none', sm: 'flex' }, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: '35px',
      }}
      >
        <Typography component="a" href="#home" sx={{ fontSize: '18px', fontWeight: '300', color: '#fff' }}>Home</Typography>
        <Typography component="a" href="#curriculum" sx={{ fontSize: '18px', fontWeight: '300', color: '#fff' }}>Curriculum</Typography>
        <Typography component="a" href="#pricing" sx={{ fontSize: '18px', fontWeight: '300', color: '#fff' }}>Pricing</Typography>
        <Typography component="a" href="#projects" sx={{ fontSize: '18px', fontWeight: '300', color: '#fff' }}>Projects</Typography>
        <Typography component="a" href="#faqs" sx={{ fontSize: '18px', fontWeight: '300', color: '#fff' }}>FAQs</Typography>
      </Box>
      <Box sx={{
        display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: { xs: '10px', sm: '35px' },
      }}
      >
        {/* <Typography sx={{ fontSize: '18px', fontWeight: '300' }}>Login</Typography> */}
        <Button onClick={handleEnroll} variant="contained" sx={{ backgroundColor: '#AE67FA', color: '#fff', '&:hover': { background: '#F49867' } }}>ENROLL</Button>
      </Box>
    </Box>
  );
};

export default Nav;
